/**
 * Links das lojas do app Bow + detecção de plataforma. Fonte única das URLs
 * (antes duplicadas no InstallPrompt) — usadas pelo banner de instalação e
 * pelo CTA da landing /qr, que desde 2026-07 empurra o app nativo (paridade
 * com os tiles dos apps parceiros).
 */

export const PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=br.app.bow';
// App real "Bow Eletropostos" (bundle br.app.bow) — id obtido via lookup público
// da App Store (itunes.apple.com/lookup?bundleId=br.app.bow) em 2026-07-05.
export const APP_STORE_URL = 'https://apps.apple.com/app/id6783809600';

/** WhatsApp do suporte — saída pro cliente que não consegue atualizar sozinho.
 *  Mesmo valor/fallback já usado em Profile, ForgotPassword e PostChargeRating. */
export const SUPPORT_WHATSAPP_URL =
  import.meta.env.VITE_SUPPORT_WHATSAPP_URL ?? 'https://wa.me/5527988231783';

/** Link da loja pela plataforma REPORTADA pelo Capacitor (`getPlatform()`),
 *  não por user-agent. Dentro do shell nativo o UA é heurística ("Android
 *  Chrome" no WebView); o plugin dá o valor exato. Usado pelo aviso
 *  "atualize o app". */
export function storeUrlForNative(platform: string): string {
  return platform === 'ios' ? APP_STORE_URL : PLAY_STORE_URL;
}

/** Detecta plataforma Apple (iOS/iPadOS). iPadOS 13+ se apresenta como
 *  "Macintosh" com tela touch, daí o segundo teste. */
export function isApplePlatform(): boolean {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent;
  if (/iphone|ipad|ipod/i.test(ua)) return true;
  return /macintosh/i.test(ua) && navigator.maxTouchPoints > 1;
}

export function isAndroidPlatform(): boolean {
  if (typeof navigator === 'undefined') return false;
  return /android/i.test(navigator.userAgent);
}

/** Android com engine Chromium (Chrome/Samsung Internet…) — os que resolvem
 *  intent:// com browser_fallback_url. Firefox e afins ficam fora e recebem
 *  o link direto da Play. Mesmo critério do detectPlatform do InstallPrompt. */
export function isAndroidChromium(): boolean {
  return isAndroidPlatform() && /chrome|samsung/i.test(navigator.userAgent);
}

/** intent:// atômico do Android: abre o app Bow já no conector se instalado
 *  (shell ≥1.2, que tem o intent-filter VIEW de bow.app.br); senão o browser
 *  cai no browser_fallback_url (página da Play). Sem timers — a resolução é
 *  do Android, não nossa. Usa o host da própria página pra dev funcionar
 *  igual a prod (o parseBowQr do app aceita os dois hosts). */
export function bowAndroidIntentUrl(
  stationId: string,
  connector: number
): string {
  const host =
    (typeof window !== 'undefined' && window.location.host) || 'bow.app.br';
  return (
    `intent://${host}/qr/${encodeURIComponent(stationId)}/${connector}` +
    `#Intent;scheme=https;package=br.app.bow;` +
    `S.browser_fallback_url=${encodeURIComponent(PLAY_STORE_URL)};end`
  );
}
